import { FILE_BASE_URL, API_BASE_URL } from '../config';

/**
 * Construye de forma segura la URL completa para un archivo.
 * @param rutaDesdeApi - La ruta del archivo tal como viene del backend.
 * @returns La URL completa y correcta.
 */
export const getFileUrl = (rutaDesdeApi: string | null | undefined): string => {
  if (!rutaDesdeApi) {
    return ''; // Devuelve una cadena vacía si no hay ruta para evitar errores.
  }

  // Si la ruta ya es una URL completa (empieza con http), usarla directamente
  if (rutaDesdeApi.startsWith('http://') || rutaDesdeApi.startsWith('https://')) {
    return rutaDesdeApi;
  }

  // En desarrollo, si la ruta ya empieza con /archivos, usar API_BASE_URL como prefijo
  if (process.env.NODE_ENV !== 'production' && rutaDesdeApi.startsWith('/archivos')) {
    return `${API_BASE_URL}${rutaDesdeApi}`;
  }

  // En producción o para rutas relativas normales
  // Asegurar que FILE_BASE_URL termine con / y rutaDesdeApi no empiece con /
  const baseUrl = FILE_BASE_URL.endsWith('/') ? FILE_BASE_URL : `${FILE_BASE_URL}/`;
  const ruta = rutaDesdeApi.startsWith('/') ? rutaDesdeApi.slice(1) : rutaDesdeApi;
  
  return `${baseUrl}${ruta}`;
}; 